import type { ReactNode } from 'react';

/**
 * AppShell constrains the app to a ~10:16 (mobile) aspect ratio on wide screens.
 * The remaining space on both sides is filled with a decorative background.
 */
export default function AppShell({ children }: { children: ReactNode }) {
  return (
    <div className="app-shell-bg flex h-full w-full items-center justify-center overflow-hidden">
      {/* Left decoration - visible only on wide screens */}
      <div className="app-shell-side hidden lg:flex" />

      {/* Main app container - 10:16 aspect ratio */}
      <div className="app-shell-main relative h-full w-full">
        {children}
      </div>

      {/* Right decoration */}
      <div className="app-shell-side hidden lg:flex" />
    </div>
  );
}
